
import util from './util'

let datas = {}

datas.maxYear = (new Date()).getFullYear();

datas.resume = {
    sexlist: [['男', '女']],
    expect_job_status: [['在职', '离职', '应届毕业生', '在校生']],
    degree: [['本科', '专科', '硕士', '博士', '其它']],
    sign: [
        "演讲能力", "团队合作", "抗压能力", "沟通协调能力", 
        "领导力", "自驱动", "PHOTOSHOP", "思维导图", 
        "谈判能力", "团队管理", "团队建设", "业务流程管理", 
        "小语种", "OA系统", "政府关系(GR)", "事业部经营", 
        "OKR管理", "办公软件", "激励管理", "目标管理", 
        "执行力", "Excel", "PPT", "Word", 
        "对外形象建立", "团队精神", "个人能力", "战略能力", 
    ],
    marriage: [['未婚','已婚','离婚','其它']],
    politics: [['党员', '预备党员', '团员', '群众', '其它']],
    arrive_time: [['随时', '一周内', '一月内', '待定']],
    type: [['全职', '实习', '兼职']],
    industry: [
        '农、林、牧、渔业', '采矿业',
        '制造业', '电力、热力、燃气及水生产和供应业',
        '建筑业',
        '批发和零售业',
        '交通运输、仓储和邮政业',
        '住宿和餐饮业',
        '信息传输、软件和信息技术服务业',
        '金融业',
        '房地产业',
        '租赁和商务服务业',
        '科学研究和技术服务业',
        '水利、环境和公共设施管理业',
        '居民服务、修理和其他服务业',
        '教育',
        '卫生和社会工作',
        '文化、体育和娱乐业',
        '公共管理、社会保障和社会组织',
        '国际组织',
        '军队'
    ], // 行业类型
}

datas.resume_need = {
    "shows": {
        "basic": "true",
        "educational": "true",
        "internship": "true",
        "experienced": "true",
        "association": "true",
        "honors": "true",
        "specialty": "true",
        "skills": "true",
        "interest": "true",
        "selfappraise": "true"
    },
    "basicsshows": {
        "sex": "true",
        "email": "true",
        "mobile": "true",
        "expectcity": "true",
        "politics": "false",
        "rest1": "false",
        "rest2": "false",
        "rest3": "false"
    },
    "icons": {
        "sex": "icon-sex",
        "bir": "icon-birthday",
        "address": "icon-address",
        "phone": "icon-phone",
        "email": "icon-email",
        "politics": "icon-reward-2",
        "rest1": "icon-school-2",
        "rest2": "icon-school-2",
        "rest3": "icon-school-2"
    },
    "sorting": {
        "record": {
            "Worked": "0",
            "Internship": "0",
            "Experienced": "0",
            "Exp_train": '0',
        },
        "append": {
            "Educational": "0",
            "Association": "0",
            "Certificate": '0',
            "Honors": "1",
            "Specialty": "1",
            "Skills": "1",
            "Interest": "1",
            "Selfappraise": "1",
            "Signs": "1",
        }
    },
    "Showreel": {
        "adjunctname": "",
        "adjunctfile": ""
    },
}

datas.salary = function(){
    var arr = [];

    for(var i=1; i<=100; i++ ){
        arr.push(i + 'k')
    }

    return [arr]
}

datas.params_prompt = {
    school_id: "请选择学校", 
    school_name: "请选择学校",
    name: "请输入你的真实姓名", 
    mobile: "请输入你常用的手机号", 
    mail: "请输入你的邮箱", 
    qq: "请输入你的QQ",
    birth: "请输入你的出生年月",
    birth_place: "请输入你的户籍所在地", 
    professional: "请输入你的专业",
    graduate_year: "请输入你的毕业年份",
    expect_job_category: "请选择你的意向职位类别",
    expect_job_status: "请选择你的求职状态",
    degree: "请选择你的最高学历",
    sex: '请选择你的性别',
    rxsj: '请选择入学时间', 
    bysj: '请选择毕业时间',
}


datas.job_category = function(callback){
    var s = sessionStorage.getItem('expect_job_category');
    if(s){
        callback(JSON.parse(s || '[]'));
        return;
    }

    util.get('index.php?r=kzp/job_category_list', {}).then(res => {
        if(res.code === 1){
            let arr_job = [];
            res.data.map((item, i) => {
                arr_job.push(item.name);
            })

            var expect_job_category = [arr_job];
            sessionStorage.setItem('expect_job_category', JSON.stringify(expect_job_category));
            callback(expect_job_category);
        }     
    })
}

// 通过sign后去用户信息
datas.getInfoBySign = function (success, callback, silent ){
    util.post('index.php?r=kzp_user/ajax_get_info_by_sign', undefined, undefined, callback, silent).then(res => {   
        const {
            code, data, msg
        } = res || {};      
        if(code === 1 && data.user_info && data.fixed_info){
            sessionStorage.setItem('userInfo', JSON.stringify(data.user_info))
            sessionStorage.setItem('fixed_info', JSON.stringify(data.fixed_info))

            let {
                openid, has_union_id
            } = data.fixed_info || {}

            if(has_union_id){
                localStorage.setItem('has_union_id', has_union_id)
            }
            
            if(!(openid)){
                util.getOpenId(window.location.href)   
                return;
            }
  
            success ? success(data): null

            util.updateCity()
        }   
  
        callback ? callback(res) : null
    });
}


// 检查信息完善信息是否完整
datas.checkPerfectinfo = function (perfect){
    const user_info = JSON.parse(sessionStorage.getItem('userInfo') || '{}');

    var check = true
    var errorInfo = ''
    for(let key in datas.params_prompt){
        if(key == 'school_id') continue
        if(user_info[key]) continue
        errorInfo = datas.params_prompt[key]
        check = false
        break
    }

    if(perfect && !check){
        util.errorFun(errorInfo || '请先完善必要信息')
    }

    return check
}

// 检查简历信息是否完整
datas.checkResumePerfect = function(data){
    var obj = {
        Worked: [],
        Experienced: [],
        Skills: [],
        Signs: [],
        Association: [],
        Internship: [],
        Exp_train: [],
        Certificate: [],
        Selfappraise: [],
        Educational: [],
        Other: [],
        Interest: [],
        Specialty: [],
        Honors: [],
    }

    for(let key in obj){
        if(data[key]){continue}

        data[key] = obj[key]
    }

    return data
}


export default datas


// WEBPACK FOOTER //
// ./src/libs/datas.js